"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseParameters = exports.serializeParameters = void 0;
var fast_json_stable_stringify_1 = __importDefault(require("fast-json-stable-stringify"));
/**
 * Сериализует параметры
 *
 * Алгоритм сериализации детерминированный
 *
 * @export
 * @param {IParameters} parameters
 * @return {*}  {string}
 */
function serializeParameters(parameters) {
    return (0, fast_json_stable_stringify_1.default)(parameters);
}
exports.serializeParameters = serializeParameters;
/**
 * Парсит сериализованные параметры
 *
 * @export
 * @param {string} serializedParameters
 * @return {*}  {IParameters}
 */
function parseParameters(serializedParameters) {
    return JSON.parse(serializedParameters);
}
exports.parseParameters = parseParameters;
//# sourceMappingURL=serialize.js.map